import React from 'react'

import { TopFilters as TopFiltersWrapper } from '@app/components'
import { LntSelect } from '@app/components/base'

import { LOCATION_KEY, MONITORINGS_TYPES_KEY } from '@app/constants/queryKeys'
import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { FILTERS_PARAMS_KEYS } from '@app/api/constants'

import { getTypes } from '@app/api/routes/monitorings'
import { getStores } from '@app/api/routes/locationStores'
import { getClusters } from '@app/api/routes/locationСlusters'
import { getClusterGroups } from '@app/api/routes/locationClusterGroups'
import { getSalesOrganization } from '@app/api/routes/locationSalesOrganization'

import { useFiltersSearch } from '@app/hooks'
import { getFilterFromEntities } from '@app/utils/entitiesAdapters'

import { commonSelectProps } from './configs'

import type { TopFilterProps } from './types'

export const TopFilters: React.FC<TopFilterProps> = ({ onSearch, initialFilters }) => {
  const { filters, canResetFilters, handleClearFilters, handleSearch, handleSelectFilterChange } = useFiltersSearch({
    initialFilters,
    onSearch
  })

  return (
    <TopFiltersWrapper
      canReset={ canResetFilters }
      onClear={ handleClearFilters }
      onSearch={ handleSearch }
    >
      <LntSelect
        { ...commonSelectProps }
        value={ filters.monitoringTypeIds ?? [] }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.monitoringTypeIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.monitoringsTypeFilter }
        querySelect={ {
          queryKey: [MONITORINGS_TYPES_KEY.typesItems],
          queryFn: getTypes,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.storeIds ?? [] }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.storeIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.storesFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationStoresItems],
          queryFn: getStores,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.clusterIds ?? [] }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.clusterIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.clustersFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationClustersItems],
          queryFn: getClusters,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.clustersGroupIds ?? [] }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.clustersGroupIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.clusterGroupsFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationClusterGroupsItems],
          queryFn: getClusterGroups,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.salesOrganizationIds ?? [] }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.salesOrganizationIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.salesOrganizationFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationSalesOrganizationsItems],
          queryFn: getSalesOrganization,
          select: getFilterFromEntities
        } }
      />
    </TopFiltersWrapper>
  )
}
